import React from 'react';
import { useTranslation } from 'react-i18next';

const Stats = () => {
  const { t } = useTranslation();

  const stats = [
    {
      key: 'satisfaction',
      order: 2
    },
    {
      key: 'areas',
      order: 1
    },
    {
      key: 'experience',
      order: 3
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <h2 className="text-4xl font-semibold bg-gradient-to-r from-[#1365c4] to-[#141e51] text-transparent bg-clip-text whitespace-pre-line">
              {t('stats.title')}
            </h2>
            <div className="space-y-6">
              <p className="text-lg font-medium text-gray-600">
                {t('stats.description1')}
              </p>
              <p className="text-lg font-medium text-gray-600">
                {t('stats.description2')}
              </p>
              <p className="text-lg font-medium font-bold text-gray-600">
                {t('stats.description3')}
              </p>
            </div>
          </div>

          {/* Right Column - Stat Cards */}
          <div className="relative grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div 
                key={stat.key}
                className={`col-start-${stat.order === 1 ? '2' : '1'} ${
                  stat.order === 2 ? 'row-start-2' : ''
                } ${
                  stat.order === 3 ? 'row-start-3 col-start-2' : ''
                } group relative rounded-2xl px-8 h-[250px] flex flex-col justify-between py-10 shadow-lg`}
                style={{
                  background: 'linear-gradient(to right, #141e51 0%, #141e51 95%, #0575d7 95%, #0575d7 100%)'
                }}
              >
                <div className="absolute bottom-0 right-0 w-full h-full bg-primaryBlue rounded-2xl translate-x-2 translate-y-2 -z-10"></div>
                <div className="text-5xl font-semibold text-white">{t(`stats.items.${stat.key}.value`)}</div>
                <div className="text-md text-gray-300 font-medium leading-tight whitespace-pre-line">
                  {t(`stats.items.${stat.key}.label`)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats; 